import React from "react";

import { useMutation } from "@tanstack/react-query";
import { Flex, theme, App } from "antd";
import { UsuarioService } from "../../Services/UsuarioService";
import { AxiosError } from "axios";
import { useCallback, useContext, useEffect } from "react";
import { SessaoContext } from "../../Contexts/SessaoContext";
import { configurarSessaoDoAxios } from "../../Services/Axios";
import { LOCAL_STORAGE_JWT_KEY } from "../../Constants";

export function Splash(props: { temaEscuro: boolean }) {
    const { notification } = App.useApp();
    const Sessao = useContext(SessaoContext);

    const { mutateAsync } = useMutation({
        mutationFn: (token: string) => new UsuarioService().validarToken(token),
        onSuccess: (data) => {
            configurarSessaoDoAxios(
                data.data.token,
                () => {
                    localStorage.setItem(LOCAL_STORAGE_JWT_KEY, "");
                    Sessao?.setSessao((prev) => ({ ...prev, token: undefined }));
                });

            Sessao?.setSessao(data.data);
        },
        onError: (error: AxiosError) => {
            // @ts-ignore
            if (error.cause?.cause === AxiosError.ERR_NETWORK || error.cause?.cause === AxiosError.ETIMEDOUT)
                notification.error({ message: "Verifique a conexão com a internet.", placement: "top" });
            else
                Sessao?.setSessao({ token: undefined });
        }
    });

    const validarToken = useCallback(async () => {
        const token = localStorage.getItem(LOCAL_STORAGE_JWT_KEY);
        if (token && token !== '') {
            try {
                await mutateAsync(token);
            } catch (error) {
                
            }
        }
        else
            Sessao?.setSessao({ token: undefined });
    }, [Sessao, mutateAsync])

    useEffect(() => {
        validarToken();
    }, [validarToken])

    return (
        <>
            <style>
                {`
            .loginBackground{
                background: linear-gradient(-45deg, ${theme.useToken().token.colorPrimary} 30%, ${theme.useToken().token.colorBgBase} 70%);
                background-size: 150% 150%;
                animation: gradient 10s ease infinite;
                height: 100vh;
            }
            @keyframes gradient {
                0% {
                  background-position: 0% 50%;
                }
                50% {
                  background-position: 50% 75%;
                }
                100% {
                  background-position: 0% 50%;
                }
            }`
                }
            </style>
            <Flex justify="center" align="center" className="loginBackground">
                <img alt="Logo Quiron" src={props.temaEscuro ? require('../../Assets/logo-quiron-branco.png') : require('../../Assets/logo-quiron.png')} style={{ width: '200px', textAlign: 'center' }} />
            </Flex>
        </>
    )
}